
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 17.32 17.32"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M8.66 17.32a8.66 8.66 0 1 1 8.66-8.66 8.67 8.67 0 0 1-8.66 8.66zM8.66 1a7.66 7.66 0 1 0 7.66 7.66A7.67 7.67 0 0 0 8.66 1z"}}),_c('path',{staticClass:"cls-2",attrs:{"d":"M5.77 12.78h3.28a4.09 4.09 0 0 0 4-3.62H5.77zM9.05 4.54H5.77v3.62h7.33a4.09 4.09 0 0 0-4.05-3.62z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M4.77 8.61v5.17h4.28a5.08 5.08 0 0 0 5-4.09 6 6 0 0 0 .09-1v-.05zm4.28 4.17H5.77V9.16h7.33a4.09 4.09 0 0 1-4.05 3.62z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M14.11 8.16a5 5 0 0 0-.91-2.47 5.21 5.21 0 0 0-2.92-2 5.11 5.11 0 0 0-1.23-.15H4.77v5.12h9.35c0-.17 0-.33-.01-.5zm-8.34 0V4.54h3.28a4.09 4.09 0 0 1 4 3.62z"}})])])])
          )
        }
      }
    